import { setTerm } from '../../../../packages/JsonQuery';
import { IDailyRentOfferForMobileSite } from '../../repositories/dailyrent/entities/daily_rent_offers_for_web/DailyRentOfferForMobileSite';
import { fetchListingOffers } from '../../services/listing/fetchListingOffers';
import { TThunkAction } from '../../types/redux';

function getPreviewOffer(offers: IDailyRentOfferForMobileSite[], realtyId: number) {
  return offers.find(offer => offer.id === realtyId);
}

export const fetchPreviewOffer =
  (realtyId: number): TThunkAction<Promise<IDailyRentOfferForMobileSite | undefined>> =>
  async (_dispatch, getState, context) => {
    const state = getState();
    const { queryString } = state;
    const { jsonQuery } = state.filters;
    const jsonQueryToFetch = setTerm('id')(setTerm('page')(jsonQuery)(1))(realtyId);
    const result = await fetchListingOffers(context, {
      jsonQuery: jsonQueryToFetch,
      queryString,
    });

    return getPreviewOffer(result.offers, realtyId);
  };
